import { TerminDoktrinalneDefinicieUpdateApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import Definicia from '../../model/Definicia';

const client = new TerminDoktrinalneDefinicieUpdateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const updateTerminDoktrinalneDefinicie = async (
  terminUuid: Uuid,
  doktrinalneDefinicie: Array<Definicia>,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { data, status } = await client.updateTerminDoktrinalneDefinicie(terminUuid, doktrinalneDefinicie, options);
  return { data, responseCode: status };
};
